import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';

import { FormLabel, FormLabelBox, CategoryName, OfferFormTitle } from '../../Common';
import PreviousOffers from './PreviousOffers';
import { DateAdapter } from './DateAdapter';
import SaveButton from './SaveButton';
import * as offerActions from '../../../redux/newOffer';
import {
  SelectTypeAdapter,
  FieldWithError,
  CheckBoxAdapter,
  CategoriesAdapter,
  CitiesAdapter,
} from './FormAdapters';
import { validate1 } from './validation';
import '../../Form.css';
import { useEffect } from 'react';

function isEmpty(obj: object) {
  for (var prop in obj) {
    return false;
  }
  return true;
}

interface Props {
  newOffer: CreateOffer;
  addOfferDetails: Function;
}

function OfferForm1(props: Props) {
  return (
    <div style={{ width: '100%' }}>
      <div />
      <PreviousOffers />
      <OfferFormTitle>CREATE A NEW OFFER</OfferFormTitle>
      <Form
        onSubmit={(state) => props.addOfferDetails(state, +1)}
        initialValues={props.newOffer}
        validate={validate1}
        render={({ handleSubmit, invalid, values, form }) => (
          <form onSubmit={handleSubmit}>
            <div className="row" style={{ position: 'relative' }}>
              <div className="col-md-6">
                <FormLabelBox>
                  <FormLabel>OFFER TYPE</FormLabel>
                </FormLabelBox>
                <Field
                  name="type"
                  render={(props) => <SelectTypeAdapter {...props} reset={form.reset} />}
                />
                <FormLabelBox>
                  <FormLabel>TITLE</FormLabel>
                </FormLabelBox>
                <FieldWithError
                  style={{ width: '300px' }}
                  name="subtitle"
                  component="input"
                  placeholder="Keep this short! Ex: Dinner + Drinks "
                />

                <FormLabelBox>
                  <FormLabel>DESCRIPTION</FormLabel>
                </FormLabelBox>
                <FieldWithError
                  name="description"
                  component="textarea"
                  rows="6"
                  placeholder="Let the models know what you’re offering."
                />
              </div>
              <div className="col-md-6">
                {['timed', 'swing_by'].includes(values && values.type) ? (
                  <div
                    className="row"
                    style={{
                      paddingLeft: '15px',
                      paddingBottom: '25px',
                      paddingTop: '20px',
                    }}
                  >
                    <div>
                      <Field
                        name="is_group"
                        render={(props) => <CheckBoxAdapter disabled={false} {...props} />}
                      />
                    </div>
                    <CategoryName>Group Offer</CategoryName>
                  </div>
                ) : null}

                {['gift', 'job', 'sponsored_content'].includes(values && values.type) ? (
                  <div>
                    <div>
                      <FormLabelBox>
                        <FormLabel>TARGET CITIES </FormLabel>
                        <FormLabel style={{ color: '#b4a361' }}>(CHECK ALL THAT APPLY)</FormLabel>
                      </FormLabelBox>

                      <FieldWithError name="city_ids" component={CitiesAdapter} />
                    </div>

                    {['job'].includes(values && values.type) ? (
                      <div>
                        <FormLabelBox>
                          <FormLabel>MODEL AVAILABILITY</FormLabel>
                          <FormLabel style={{ color: '#b4a361' }}>(TIME RANGE FOR JOB)</FormLabel>
                        </FormLabelBox>

                        <div>
                          <FormLabelBox>
                            <FormLabel>START DATE</FormLabel>
                          </FormLabelBox>
                          <FieldWithError name="display_start_date" component={DateAdapter} />
                        </div>

                        <div>
                          <FormLabelBox>
                            <FormLabel>END DATE</FormLabel>
                          </FormLabelBox>
                          <FieldWithError name="display_end_date" component={DateAdapter} />
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div>
                    <FormLabelBox>
                      <FormLabel>CATEGORIES </FormLabel>
                      <FormLabel style={{ color: '#b4a361' }}>(CHECK ALL THAT APPLY)</FormLabel>
                    </FormLabelBox>

                    <FieldWithError name="categories" component={CategoriesAdapter} />
                  </div>
                )}

                <SaveButton click={handleSubmit} ready={!invalid && isEmpty(validate1(values))} />
              </div>
            </div>
          </form>
        )}
      />
    </div>
  );
}

export default connect(
  ({ newOffer }: { newOffer: CreateOffer }) => ({ newOffer }),
  offerActions
)(OfferForm1);
